import { render } from "./OverviewWrapper.vue?vue&type=template&id=f4156a44&ts=true"
import script from "./OverviewWrapper.ts?vue&type=script&lang=ts&external"
export * from "./OverviewWrapper.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__